import { useState } from 'react';
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import Integrations from "./components/Integrations";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CompanyLogos from "./components/CompanyLogos";
import { ThemeProvider } from './context/ThemeContext';
import SignUpModal from './components/SignUpModal';
import Testimonials from "./components/Testimonials";
import Stats from "./components/Stats";

function App() {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const handleGetStarted = () => {
    setIsSignUpOpen(true);
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen overflow-hidden bg-white dark:bg-[#0A0F1C] text-textDark dark:text-white transition-colors duration-200">
        {/* Background Gradients */}
        <div className="fixed inset-0 pointer-events-none">
          {/* Top gradient */}
          <div className="absolute top-0 left-1/4 w-[70rem] h-[40rem] bg-gradient-to-r from-indigo-500/20 via-purple-500/20 to-pink-500/20 blur-[128px] -translate-y-1/2" />
          {/* Bottom gradient */}
          <div className="absolute bottom-0 right-1/4 w-[70rem] h-[40rem] bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-indigo-500/20 blur-[128px] translate-y-1/2" />
        </div>

        {/* Content */}
        <div className="relative">
          <Header onGetStarted={handleGetStarted} />
          
          <main className="relative z-10">
            {/* Hero Section */}
            <section id="hero" className="pt-[4.75rem] lg:pt-[5.25rem]">
              <Hero onGetStarted={handleGetStarted} />
            </section>

            {/* Company Logos */}
            <CompanyLogos />

            {/* Features Section */}
            <Features />

            {/* Services Section */}
            <section id="services">
              <Services />
            </section>

            {/* Stats Section */}
            <section id="stats" className="py-20">
              <Stats />
            </section>

            {/* Testimonials Section */}
            <section id="testimonials">
              <Testimonials />
            </section>

            {/* Integrations Section */}
            <section id="integrations">
              <Integrations />
            </section>

            {/* Pricing Section */}
            <section id="pricing">
              <Pricing onGetStarted={handleGetStarted} />
            </section>

            {/* FAQ Section */}
            <section id="faq">
              <FAQ />
            </section>
          </main>

          <Footer />
        </div>

        {/* Sign Up Modal */}
        <SignUpModal 
          isOpen={isSignUpOpen} 
          onClose={() => setIsSignUpOpen(false)} 
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
